/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');
const container = require('./../../../../core/container');
const Translator = require('./../../../../core/translator');

const Loader = require('./../../../../services/loader');

const formatBytes = require('./../formatBytes');

const tpl = require('./template/dropzone.hbs');

module.exports.createInput = (config, $dropzone) => {
  let $input = jQuery('<input type="file" />');

  if (config.multiple) {
    $input.attr('multiple', true);
  }

  if (config['accepted_files']) {
    $input.attr('accept', config['accepted_files']);
  }

  $input.on('change', function() {
    if (typeof config.onChange === 'function') {
      let files = jQuery(this).get(0).files;
      let maxSize = container.get('$toolbar').data('maxSize');
      let $errorText;
      let isUploadable = true;
      let $navSecondary = jQuery('#cloud-nav-secondary');

      if (container.get('isMobile') && $navSecondary.find('.icon-image').length === 1) {
        $errorText = jQuery('#cloud-nav-primary').find('.text-danger');
      } else {
        $errorText = $dropzone.parents().find('.text-danger');
      }

      if ($errorText.length !== 0) {
        $errorText.remove();
      }

      for (let file in files) {
        if (files.hasOwnProperty(file)) {
          if (files[file].size > maxSize) {
            isUploadable = false;
          }
        }
      }

      if (isUploadable) {
        if ($dropzone.find('.cloud-mask-loader').length === 0) {
          Loader.start($dropzone);

          config.onChange(config.multiple ? files : files[0]);
        }
      } else {
        if (container.get('isMobile') && $navSecondary.find('.icon-image').length === 1) {
          let $navPrimary = jQuery('#cloud-nav-primary');
          $navPrimary.append('<p class="text-danger text-center font-weight-bold mt-2 ml-4 mb-2">' + Translator.translate('large_file_upload', {'size': formatBytes.format(maxSize)}) + '</p>');
        } else {
          $dropzone.parent().before('<p class="text-danger text-center font-weight-bold mt-2 ml-4 mb-2">' + Translator.translate('large_file_upload', {'size': formatBytes.format(maxSize)}) + '</p>');
        }
      }
    }
  });

  return $input;
};

module.exports.create = (config) => {
  let label = config.label || 'drop_image_file';
  let icon = config.icon || 'icon-new-post';
  let maxSize = formatBytes.format(container.get('$toolbar').data('maxSize'));
  let $body = jQuery('body');

  let $dropzone = jQuery(tpl({
    'label': label,
    'show_max_size': (maxSize.slice(0, -1) < 20),
    'label_size': Translator.translate('drop_image_size', {'size': maxSize}),
    'icon': icon,
  }));

  if (config.classes) {
    $dropzone.addClass(config.classes);
  }

  $body.on('dragenter', $dropzone, function(event) {
    event.preventDefault();
  });

  $body.on('dragover', $dropzone, function(event) {
    event.preventDefault();
  });

  $body.on('dragleave', $dropzone, function(event) {
    event.preventDefault();
  });

  $body.on('drop', $dropzone, function(event) {
    event.preventDefault();

    if (typeof config.onChange === 'function' && $dropzone.is(':visible') && $dropzone.find('.cloud-mask-loader').length === 0) {
      let files = event.originalEvent.dataTransfer.files;

      Loader.start($dropzone);

      config.onChange(config.multiple ? files : files[0]);

      Loader.stop($dropzone);
    }
  });

  $dropzone.on('click', function() {
    let $input = module.exports.createInput(config, $dropzone);

    $input.click();
  });

  return $dropzone;
};
